/**
 * Note that this method is very primitive and just adds a suffix on 's'
 * Words like mouse -> mice will not work well
 * @param word {string}
 * @param count {number}
 * @returns {string}
 */
export const pluralizeWord = (word, count) => `${word}${count === 1 ? '' : 's'}`;
